// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"97":"528c4bc3","978":"c3d63058","997":"9c4b8021"}[chunkId] + ".js";
};